import React, { useEffect, useState } from "react";
import {
  Box,
  Paper,
  Button,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Divider,
  CircularProgress
} from '@mui/material';
import Header from "../Header";
import Footer from "../Footer";
import { useParams } from "react-router-dom";
import config from "../common/Config";
import { fetchProformaInvoice } from '../../utils/proformaInvoiceApi';
import Grid from "@mui/material/Grid2";
import { Iconify } from "../Minimal/src/components/iconify/iconify";
import generateSummaryPDF_dds from "./generateSummaryPDF_dds";
import generateSummaryPDF_tsc from "./generateSummaryPDF_tsc";
import generateSummaryPDF_knm from "./generateSummaryPDF_knm";
import generateSummaryPDF_sdm from "./generateSummaryPDF_sdm";
import generateSummaryPDF_eve from "./generateSummaryPDF_eve";
import generateSummaryPDF_rhv from "./generateSummaryPDF_rhv";
import "../common/commonStyles.css";

const SummaryPrint = (props) => {
  const { orderId } = useParams();
  const [shopDetails, setShopDetails] = useState({});
  const [orderDetails, setOrderDetails] = useState({});
  const [productDetails, setProductDetails] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [totalVal, setTotalVal] = useState({
    totalstd: 0,
    totalzeroGoods: 0,
    totalTax: 0,
    orderDiscount: 0,
    grandTotal: 0,
    over_all_discount: 0,
    over_all_amount: 0,
    totalCess: 0,
    promoDiscount: 0,
    total_promo_discount: 0,
    total_promo_discount_vat: 0,
  });

  const accessToken = localStorage.getItem("accessToken");
  const token = localStorage.getItem('token');
  const company_tax_type = localStorage.getItem('company_tax_type');
  const currencySymbol = localStorage.getItem("currencySymbol") || '£';
  const showCessRate = localStorage.getItem("showCessRate");

  const formatCurrency = (value) => {
    return `${currencySymbol}${parseFloat(value || 0).toFixed(2)}`;
  };

  const formatType = (value) => {
    if (!value) return "Box";
    const stringValue = String(value);
    return stringValue.charAt(0).toUpperCase() + stringValue.slice(1);
  };

  const fetchInvoice = async () => {
    try {
      setIsLoading(true);
      const data = await fetchProformaInvoice(orderId, token);

      setShopDetails(data.details.shop_details || {});
      setOrderDetails(data.details.orderDetails[0] || {});
      setProductDetails(data.details.product_details || []);

      const products = data.details.product_details || [];
      const order = data.details.orderDetails[0] || {};
      const totals = data.details.totals || {};
      const bundleDiscounts = Array.isArray(data.details.bundle_discounts) ? data.details.bundle_discounts : [];
      const toNumber = (v) => {
        const n = parseFloat(v);
        return Number.isFinite(n) ? n : 0;
      };

      let calcTotalStdGoods = 0;
      let calcVatAmount = 0;
      let calcTotalZeroGoods = 0;
      products.forEach((product) => {
        const subtotal = parseFloat(product.subtotal || 0);
        const tax = parseFloat(product.item_tax || 0);
        const taxPercent = parseFloat(product.tax_rate_percent || 0);
        calcVatAmount += tax;
        if (taxPercent === 0) {
          calcTotalZeroGoods += subtotal;
        } else {
          calcTotalStdGoods += subtotal;
        }
      });

      const totalStdGoods = order.total_std_goods != null && order.total_std_goods !== ""
        ? parseFloat(order.total_std_goods)
        : calcTotalStdGoods;
      const vatAmount = order.total_tax != null && order.total_tax !== ""
        ? parseFloat(order.total_tax)
        : calcVatAmount;
      const totalZeroGoods = order.total_zero_goods != null && order.total_zero_goods !== ""
        ? parseFloat(order.total_zero_goods)
        : calcTotalZeroGoods;
      let totalPromoDiscount = bundleDiscounts.reduce(
        (sum, b) => sum + toNumber(b.total_discount || (toNumber(b.buy_total_discount) + toNumber(b.get_total_discount))),
        0
      );
      let totalPromoDiscountVat = bundleDiscounts.reduce(
        (sum, b) => sum + toNumber(b.buy_discount_vat) + toNumber(b.get_discount_vat),
        0
      );

      if (totalPromoDiscount <= 0) {
        totalPromoDiscount = toNumber(
          totals.total_promo_discount ??
          order.total_promo_discount ??
          totals.promo_discount ??
          order.promo_discount ??
          order.order_discount1
        );
      }
      if (totalPromoDiscountVat <= 0) {
        totalPromoDiscountVat = toNumber(
          totals.total_promo_discount_vat ??
          order.total_promo_discount_vat ??
          totals.promo_discount_vat ??
          order.promo_discount_vat
        );
      }
      const promotionalDiscount = totalPromoDiscount;
      const grandTotal = order.grand_total != null && order.grand_total !== ""
        ? parseFloat(order.grand_total)
        : calcTotalStdGoods + calcVatAmount + calcTotalZeroGoods;
      const totalInvDiscPercent = parseFloat(order.over_all_discount || 0);
      const totalInvDiscAmount = parseFloat(order.over_all_amount || 0);

      let totalCess = 0;
      if (showCessRate === 'Y') {
        totalCess = order.total_cess != null && order.total_cess !== ""
          ? parseFloat(order.total_cess)
          : products.reduce((sum, item) => {
            const itemSubtotal = parseFloat(item.subtotal) || 0;
            const itemCessRate = parseFloat(item.cess_rate_percent) || 0;
            return sum + ((itemSubtotal * itemCessRate) / 100);
          }, 0);
      }

      setTotalVal({
        totalstd: totalStdGoods,
        totalzeroGoods: totalZeroGoods,
        totalTax: vatAmount,
        orderDiscount: parseFloat(order.order_discount || 0),
        promoDiscount: promotionalDiscount,
        grandTotal,
        over_all_discount: totalInvDiscPercent,
        over_all_amount: totalInvDiscAmount,
        totalCess: parseFloat(totalCess),
        total_promo_discount: totalPromoDiscount,
        total_promo_discount_vat: totalPromoDiscountVat,
      });

    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (accessToken === null) {
      window.location.href = `${config.BASE_URL}/login`;
      return;
    }
    fetchInvoice();
  }, []);

  const getRowTextColor = (row) => {
    if (row.discount == '100.00' || row.discount == 100.00) {
      return '#f14240';
    } else if (row.unit_quantity != row.quantity) {
      return '#009688';
    }
    return '#212b36';
  };

  const handleGenerateDeliveryNotePDF = (e, orderId) => {
    const accessToken = localStorage.getItem('accessToken');
    if (accessToken === "dds" || accessToken === "ddd" || accessToken === "dan") {
      generateSummaryPDF_dds(orderId);
    } else if (accessToken === "tsc" || accessToken === "tss") {
      generateSummaryPDF_tsc(orderId);
    } else if (accessToken === "knm") {
      generateSummaryPDF_knm(orderId);
    } else if (accessToken === "sdm") {
      generateSummaryPDF_sdm(orderId);
    } else if (accessToken === "eve") {
      generateSummaryPDF_eve(orderId);
    } else if (accessToken === "rhv" || accessToken === "hv") {
      generateSummaryPDF_rhv(orderId);
    } else {
      generateSummaryPDF_dds(orderId);
    }
  };

  const labelStyle = {
    fontSize: { xs: "0.75rem", md: "0.875rem" },
    fontWeight: 500,
    color: "#212b36",

  };

  const valueStyle = {
    color: "#637381",
    fontSize: "0.8rem",

  };

  if (isLoading) {
    return (
      <>
        {/* <Header /> */}
        <Box sx={{ backgroundColor: "#f5f7fa", minHeight: "100vh", my: 6 }}>
          <Box sx={{ width: "100%", px: { xs: 2, md: 3 }, py: 2 }}>
            <Paper
              elevation={0}
              sx={{
                borderRadius: 2,
                border: "1px solid rgba(145, 158, 171, 0.16)",
                overflow: "hidden",
                backgroundColor: "#fff",
                p: 3,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "400px"
              }}
            >
              <CircularProgress />
            </Paper>
          </Box>
        </Box>

      </>
    );
  }

  if (!orderDetails || !shopDetails) {
    return (
      <>
        {/* <Header /> */}
        <Box sx={{ backgroundColor: "#f5f7fa", minHeight: "100vh", p: 1.5 }}>
          <Paper
            elevation={0}
            sx={{
              borderRadius: 2,
              border: "1px solid rgba(145, 158, 171, 0.16)",
              overflow: "hidden",
              backgroundColor: "#fff",
              p: 3,
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "400px",
              gap: 2
            }}
          >
            <Iconify icon="solar:clipboard-remove-bold" width={120} sx={{ color: "#637381" }} />
            <Typography variant="h5" sx={{ color: "#212b36", fontWeight: 600 }}>
              Invoice Not found
            </Typography>
          </Paper>
        </Box>

      </>
    );
  }

  return (
    <>
      <Box className="page-container">
        <Paper
          className="paper-style"
        >
          <Box sx={{ px: 2, py: 1 }}>
            <Grid container spacing={2} display="flex" justifyContent="space-between" alignItems="center">
              <Grid size={{ xs: 12, md: 6 }}>
                <Typography sx={{ fontWeight: 600, color: "#212b36", fontSize: "1.25rem" }}>
                  Invoice Details
                </Typography>
              </Grid>
              <Grid size={{ xs: 12, md: 6 }} sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
                <Button
                  variant="contained"
                  className="button-variant-contained"
                  startIcon={<Iconify icon="solar:printer-bold" width={16} />}
                  onClick={(e) => handleGenerateDeliveryNotePDF(e, orderId)}
                >
                  Print Invoice
                </Button>
              </Grid>
            </Grid>
          </Box>

          <Box sx={{ px: 2, py: 1 }}>
            <Grid container spacing={2} justifyContent={{ xs: "center", md: "flex-start" }}>
              <Grid size={{ xs: 12, md: 4 }}>
                <Box>
                  <Typography className="innvoice-row-item">
                    <Typography className="innvoice-title">Customer Name:</Typography>
                    <Typography className="innvoice-subtitle">{orderDetails.company || ""}</Typography>
                  </Typography>
                  <Typography className="innvoice-row-item">
                    <Typography className="innvoice-title">Address:</Typography>
                    <Typography className="innvoice-subtitle">
                      {`${orderDetails.address || ""}, ${orderDetails.city || ""}, ${orderDetails.postal_code || ""}`.replace(/^,\s*|,\s*$/g, '')}
                    </Typography>
                  </Typography>
                  <Typography className="innvoice-row-item">
                    <Typography className="innvoice-title">Customer a/c No.</Typography>
                    <Typography className="innvoice-subtitle">{orderDetails.account_no || ""}</Typography>
                  </Typography>
                </Box>
              </Grid>
              <Grid size={{ xs: 12, md: 4 }}>
                <Box>
                  <Typography className="innvoice-row-item">
                    <Typography className="innvoice-title">Tel:</Typography>
                    <Typography className="innvoice-subtitle">{shopDetails.phone || ""}</Typography>
                  </Typography>
                  <Typography className="innvoice-row-item">
                    <Typography className="innvoice-title">Email:</Typography>
                    <Typography className="innvoice-subtitle">{orderDetails.email || ""}</Typography>
                  </Typography>
                  <Typography className="innvoice-row-item">
                    <Typography className="innvoice-title">Order Date:</Typography>
                    <Typography className="innvoice-subtitle">{orderDetails.invoice_date || ""}</Typography>
                  </Typography>
                </Box>
              </Grid>
              <Grid size={{ xs: 12, md: 4 }}>
                <Box>
                  <Typography className="innvoice-row-item">
                    <Typography className="innvoice-title">Invoice No:</Typography>
                    <Typography className="innvoice-subtitle">INV{orderDetails.reference_no || ""}</Typography>
                  </Typography>
                  <Typography className="innvoice-row-item">
                    <Typography className="innvoice-title">Sale Status:</Typography>
                    <Typography className="innvoice-subtitle">{orderDetails.sale_status || ""}</Typography>
                  </Typography>
                  <Typography className="innvoice-row-item">
                    <Typography className="innvoice-title">Trip No:</Typography>
                    <Typography className="innvoice-subtitle">{orderDetails.trip_no || ""}</Typography>
                  </Typography>
                  <Typography className="innvoice-row-item">
                    <Typography className="innvoice-title">Cust Order Id:</Typography>
                    <Typography className="innvoice-subtitle">{orderDetails.reference_no || ""}</Typography>
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Box>
          <TableContainer sx={{ overflowX: "auto" }}>
            <Table
              className="table-cell-border"
            >
              <TableHead>
                <TableRow className="table-cell-header">
                  <TableCell sx={{ width: "300px" }}>Product Description</TableCell>
                  {showCessRate === 'Y' && (
                    <TableCell sx={{ width: "10%" }}>HSN Code</TableCell>
                  )}
                  <TableCell align="center" sx={{ width: "50px" }}>Qty</TableCell>
                  <TableCell align="center" sx={{ width: "50px" }}>Type</TableCell>
                  <TableCell align="right" sx={{ width: "70px" }}>Unit Price</TableCell>
                  <TableCell align="right" sx={{ width: "70px" }}>Discount</TableCell>
                  <TableCell align="right" sx={{ width: "70px" }}>{company_tax_type} Amount</TableCell>
                  {showCessRate === 'Y' && (
                    <TableCell align="right" sx={{ width: "50px" }}>Cess Amount</TableCell>
                  )}
                  <TableCell align="right" sx={{ width: "70px" }}>Net Amount</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {productDetails && productDetails.length > 0 ? (
                  productDetails.map((row, index) => {
                    const textColor = getRowTextColor(row);
                    const itemSubtotal = parseFloat(row.subtotal) || 0;
                    const itemCessRate = parseFloat(row.cess_rate_percent) || 0;
                    const itemCessAmt = ((itemSubtotal * itemCessRate) / 100).toFixed(2);
                    const isEmptyHSN = !row.hsn_code || row.hsn_code.trim() === '';
                    const rawDiscountType = row.productWiseDiscountType || row.discount_type || "amount";
                    const discountType = String(rawDiscountType).toLowerCase() === "percentage" ? "percentage" : "amount";
                    const discountValue = discountType === "percentage"
                      ? parseFloat(row.discount ?? row.discount_percentage ?? 0)
                      : parseFloat(row.item_discount ?? 0);

                    return (
                      <TableRow
                        key={index}

                        sx={{
                          '&:hover': {
                            backgroundColor: 'rgba(145, 158, 171, 0.04)'
                          },
                          transition: 'background-color 0.2s ease',
                          "& .MuiTableCell-root": {
                            fontSize: "0.75rem",
                            color: textColor,
                            py: 1,
                          },
                          "& .MuiTypography-root": {
                            fontSize: "0.75rem",
                            color: textColor,
                            display: "block",
                          },

                        }}
                      >
                        <TableCell >
                          <Typography variant="body2" >
                            {row.product_code} - {row.product_name}{row.promo_product}{row.free_product}{row.ContractPrice}
                          </Typography>
                        </TableCell>
                        {showCessRate === 'Y' && (
                          <TableCell sx={{ fontSize: "0.75rem", color: (row.discount == "100.00" || row.discount == 100.0) && isEmptyHSN ? 'red' : textColor, py: 1 }}>
                            <Typography variant="body2" sx={{ fontSize: "0.75rem" }}>
                              {isEmptyHSN ? ((row.discount == "100.00" || row.discount == 100.0) ? 'N/A' : '-') : row.hsn_code}
                            </Typography>
                          </TableCell>
                        )}
                        <TableCell align="center">
                          <Typography variant="body2" >{parseInt(row.quantity)}</Typography>
                        </TableCell>
                        <TableCell align="center">
                          <Typography variant="body2" >{formatType(row.order_type)}</Typography>
                        </TableCell>
                        <TableCell align="right">
                          <Typography variant="body2" >
                            {formatCurrency(row.unit_price)}
                          </Typography>
                        </TableCell>
                        <TableCell align="right" >
                          <Typography variant="body2" >
                            {discountType === "percentage"
                              ? `${discountValue.toFixed(2)}%`
                              : formatCurrency(discountValue)}
                          </Typography>
                        </TableCell>
                        <TableCell align="right" >
                          <Typography variant="body2" >
                            {row.item_tax ? formatCurrency(row.item_tax) : formatCurrency(0)}
                          </Typography>
                        </TableCell>
                        {showCessRate === 'Y' && (
                          <TableCell align="right" sx={{ fontSize: "0.75rem", color: textColor, py: 1 }}>
                            <Typography variant="body2" sx={{ fontSize: "0.75rem", color: textColor }}>
                              {formatCurrency(itemCessAmt)}
                            </Typography>
                          </TableCell>
                        )}
                        <TableCell align="right" sx={{ fontSize: "0.75rem", color: textColor, fontWeight: 600, py: 1 }}>
                          <Typography variant="body2" sx={{ fontSize: "0.75rem", color: textColor, fontWeight: 600 }}>
                            {row.subtotal ? formatCurrency(row.subtotal) : formatCurrency(0)}
                          </Typography>
                        </TableCell>
                      </TableRow>
                    );
                  })
                ) : (
                  <TableRow>
                    <TableCell
                      colSpan={showCessRate === 'Y' ? 9 : 8}
                      sx={{ py: 8 }}
                    >
                      <Typography align="center" sx={{ color: "#637381", fontSize: "0.875rem" }}>
                        No products found.
                      </Typography>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>

          <Grid container spacing={2} px={2} mt={1}>
            <Grid size={{ xs: 12, md: 6 }} />
            <Grid size={{ xs: 12, md: 6 }}>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: { xs: 0.75, sm: 0.5 } }}>
                <Box className="innvoice-summary-align">
                  <Typography className="innvoice-summary-title">Total VAT Goods</Typography>
                  <Typography className="innvoice-summary-value">
                    {formatCurrency(totalVal.totalstd)}
                  </Typography>
                </Box>
                <Box className="innvoice-summary-align">
                  <Typography className="innvoice-summary-title">{company_tax_type} Amount</Typography>
                  <Typography className="innvoice-summary-value">
                    {formatCurrency(totalVal.totalTax)}
                  </Typography>
                </Box>
                {showCessRate === 'Y' && (
                  <Box className="innvoice-summary-align">
                    <Typography className="innvoice-summary-title">Cess Amount</Typography>
                    <Typography className="innvoice-summary-value">
                      {formatCurrency(totalVal.totalCess)}
                    </Typography>
                  </Box>
                )}
                <Box className="innvoice-summary-align">
                  <Typography className="innvoice-summary-title">Total Zero VAT Goods</Typography>
                  <Typography className="innvoice-summary-value">
                    {formatCurrency(totalVal.totalzeroGoods)}
                  </Typography>
                </Box>
                <Box className="innvoice-summary-align">
                  <Typography className="innvoice-summary-title">Order Discount</Typography>
                  <Typography className="innvoice-summary-value">
                    {totalVal.over_all_discount > 0
                      ? `${totalVal.over_all_discount.toFixed(2)}% (${formatCurrency(totalVal.over_all_amount)})`
                      : `${totalVal.over_all_discount.toFixed(2)}%`}
                  </Typography>
                </Box>
                {/* <Box sx={{ display: "flex", gap: 1.5, justifyContent: "flex-end", alignItems: "center" }}>
                      <Typography variant="body2" sx={{ fontWeight: 600, color: "#212b36", fontSize: "0.8rem" }}>Promo Discount</Typography>
                      <Typography variant="body2" sx={{ color: "#212b36", fontSize: "0.875rem", minWidth: 80, textAlign: "right" }}>
                        {formatCurrency(totalVal.promoDiscount || 0)}
                      </Typography>
                    </Box> */}
                <Box className="innvoice-summary-align">
                  <Typography className="innvoice-summary-title">Promo VAT</Typography>
                  <Typography className="innvoice-summary-value">
                    {formatCurrency(totalVal.total_promo_discount_vat || 0)}
                  </Typography>
                </Box>
                <Box className="innvoice-summary-align">
                  <Typography className="innvoice-summary-title">Promo Discount</Typography>
                  <Typography className="innvoice-summary-value">
                    {formatCurrency(totalVal.total_promo_discount || 0)}
                  </Typography>
                </Box>

                <Divider sx={{ my: 0.5, borderColor: "rgba(145, 158, 171, 0.16)" }} />
                <Box className="innvoice-summary-align">
                  <Typography className="innvoice-summary-title">Invoice Total</Typography>
                  <Typography className="innvoice-summary-value">
                    {formatCurrency(totalVal.grandTotal)}
                  </Typography>
                </Box>
              </Box>
            </Grid>
          </Grid>

          {(orderDetails.picker_note || orderDetails.staff_note) ? (
            <Box sx={{ mt: 2, mb: 1 }}>
              {orderDetails.staff_note ? (
                <Typography className="innvoice-row-item" sx={{ mb: 0.5 }}>
                  <Typography className="innvoice-title">Note:</Typography>
                  <Typography className="innvoice-subtitle" sx={{ whiteSpace: "pre-wrap" }}>
                    {orderDetails.staff_note}
                  </Typography>
                </Typography>
              ) : null}
              {orderDetails.picker_note ? (
                <Typography className="innvoice-row-item">
                  <Typography className="innvoice-title">Picker Note:</Typography>
                  <Typography className="innvoice-subtitle" sx={{ whiteSpace: "pre-wrap" }}>
                    {orderDetails.picker_note}
                  </Typography>
                </Typography>
              ) : null}
            </Box>
          ) : null}

          <Box className="invoice-footer-section">
            <Typography className="invoice-footer-text">
              No claims for damages or short delivery will be considered unless made at the time of delivery of goods. These goods are not sold on a sale or return basis.
            </Typography>
          </Box>
        </Paper>
      </Box>

    </>
  );
};

export default SummaryPrint;
